<template>
  <i18n-t v-if="isDiscountedGame" keypath="landingpage/price_starting">
    <template #days>{{ game.startConfiguration.duration }}</template>
    <template #price>
      <s>{{ startingPrice }}</s> <b>{{ discountedStartingPrice }}</b>
    </template>
  </i18n-t>
  <template v-else>
    {{ notDiscountedGameMessage }}
  </template>
</template>

<script lang="ts">
import { type StrapiProduct } from '~/apollo/types/types';

export default defineComponent({
  name: 'DiscountedGame',
  components: {},
  props: {
    game: {
      type: Object as PropType<StrapiProduct>,
      required: true,
    },
    isDiscountedGame: {
      type: Boolean,
      default: false,
    },
    notDiscountedGameMessage: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { t } = useI18n();
    const { formatStrapiPrice } = useNumberMoneyFormatting();

    const startingPrice = computed<string>(() =>
      formatStrapiPrice(props.game.startConfiguration.prices[0]),
    );

    const discountedStartingPrice = computed<string>(() =>
      formatStrapiPrice(
        props.game.startConfiguration.prices[0],
        props.game.discountedPercentage / 100,
      ),
    );

    return {
      startingPrice,
      discountedStartingPrice,
      t,
    };
  },
});
</script>

<style lang="scss"></style>
